import type { SVGProps } from 'react';

export interface SVGSuccessAnimationProps extends SVGProps<SVGSVGElement> {
  loop?: boolean;
}

const SVGSuccessAnimation = ({ loop = false, ...props }: SVGSuccessAnimationProps) => {
  const repeatCount = loop ? 'indefinite' : '1';

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      preserveAspectRatio='xMidYMid meet'
      width='128'
      height='128'
      viewBox='0 0 128 128'
      {...props}
    >
      <defs>
        <animate
          repeatCount={repeatCount}
          dur='5.5s'
          begin='0s'
          xlinkHref='#_R_G_L_24_G_D_0_P_0'
          fill='freeze'
          attributeName='d'
          attributeType='XML'
          from='M-283.92 75.71 C-283.92,75.71 -284.2,75.68 -284.2,75.68 '
          to='M-432.65 75.71 C-432.65,75.71 -432.5,75.71 -432.5,75.71 '
          keyTimes='0;0.2727273;0.3030303;0.3257576;0.3560606;0.4318182;0.4621212;0.4848485;0.5151515;0.5984848;0.6287879;0.6515152;0.6818182;1'
          values='M-283.92 75.71 C-283.92,75.71 -284.2,75.68 -284.2,75.68 ;M-283.92 75.71 C-283.92,75.71 -284.2,75.68 -284.2,75.68 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-432.65 75.71 C-432.65,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -284.2,75.68 -284.2,75.68 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-432.65 75.71 C-432.65,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -284.2,75.68 -284.2,75.68 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-432.65 75.71 C-432.65,75.71 -432.5,75.71 -432.5,75.71 ;M-432.65 75.71 C-432.65,75.71 -432.5,75.71 -432.5,75.71 '
          keySplines='0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0'
          calcMode='spline'
        />
        <animate
          repeatCount={repeatCount}
          dur='5.5s'
          begin='0s'
          xlinkHref='#_R_G_L_24_G_M'
          fill='freeze'
          attributeName='opacity'
          from='0'
          to='0'
          keyTimes='0;0.2727273;0.272728;0.3636364;0.3636364;1'
          values='0;0;1;1;0;0'
          keySplines='0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0'
          calcMode='spline'
        />
        <animate
          repeatCount={repeatCount}
          dur='5.5s'
          begin='0s'
          xlinkHref='#_R_G_L_23_G_D_0_P_0'
          fill='freeze'
          attributeName='d'
          attributeType='XML'
          from='M-283.92 75.71 C-283.92,75.71 -284.2,75.68 -284.2,75.68 '
          to='M-432.65 75.71 C-432.65,75.71 -432.5,75.71 -432.5,75.71 '
          keyTimes='0;0.2727273;0.3030303;0.3257576;0.3560606;0.4318182;0.4621212;0.4848485;0.5151515;0.5984848;0.6287879;0.6515152;0.6818182;1'
          values='M-283.92 75.71 C-283.92,75.71 -284.2,75.68 -284.2,75.68 ;M-283.92 75.71 C-283.92,75.71 -284.2,75.68 -284.2,75.68 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-432.65 75.71 C-432.65,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -284.2,75.68 -284.2,75.68 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-432.65 75.71 C-432.65,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -284.2,75.68 -284.2,75.68 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-432.65 75.71 C-432.65,75.71 -432.5,75.71 -432.5,75.71 ;M-432.65 75.71 C-432.65,75.71 -432.5,75.71 -432.5,75.71 '
          keySplines='0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0'
          calcMode='spline'
        />
        <animate
          repeatCount={repeatCount}
          dur='5.5s'
          begin='0s'
          xlinkHref='#_R_G_L_23_G_M'
          fill='freeze'
          attributeName='opacity'
          from='0'
          to='0'
          keyTimes='0;0.2727273;0.272728;0.3636364;0.3636364;1'
          values='0;0;1;1;0;0'
          keySplines='0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0'
          calcMode='spline'
        />
        <animate
          repeatCount={repeatCount}
          dur='5.5s'
          begin='0s'
          xlinkHref='#_R_G_L_22_G_D_0_P_0'
          fill='freeze'
          attributeName='d'
          attributeType='XML'
          from='M-283.92 75.71 C-283.92,75.71 -284.2,75.7 -284.2,75.7 '
          to='M-431.97 75.71 C-431.97,75.71 -432.5,75.71 -432.5,75.71 '
          keyTimes='0;0.2727273;0.3030303;0.3257576;0.3560606;0.4318182;0.4621212;0.4848485;0.5151515;0.5984848;0.6287879;0.6515152;0.6818182;1'
          values='M-283.92 75.71 C-283.92,75.71 -284.2,75.7 -284.2,75.7 ;M-283.92 75.71 C-283.92,75.71 -284.2,75.7 -284.2,75.7 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-431.97 75.71 C-431.97,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -284.2,75.7 -284.2,75.7 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-431.97 75.71 C-431.97,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -284.2,75.7 -284.2,75.7 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-431.97 75.71 C-431.97,75.71 -432.5,75.71 -432.5,75.71 ;M-431.97 75.71 C-431.97,75.71 -432.5,75.71 -432.5,75.71 '
          keySplines='0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0'
          calcMode='spline'
        />
        <animate
          repeatCount={repeatCount}
          dur='5.5s'
          begin='0s'
          xlinkHref='#_R_G_L_22_G_M'
          fill='freeze'
          attributeName='opacity'
          from='0'
          to='0'
          keyTimes='0;0.2727273;0.272728;0.3636364;0.3636364;1'
          values='0;0;1;1;0;0'
          keySplines='0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0'
          calcMode='spline'
        />
        <animate
          repeatCount={repeatCount}
          dur='5.5s'
          begin='0s'
          xlinkHref='#_R_G_L_21_G_D_0_P_0'
          fill='freeze'
          attributeName='d'
          attributeType='XML'
          from='M-283.92 75.71 C-283.92,75.71 -284.2,75.7 -284.2,75.7 '
          to='M-431.97 75.71 C-431.97,75.71 -432.5,75.71 -432.5,75.71 '
          keyTimes='0;0.2727273;0.3030303;0.3257576;0.3560606;0.4318182;0.4621212;0.4848485;0.5151515;0.5984848;0.6287879;0.6515152;0.6818182;1'
          values='M-283.92 75.71 C-283.92,75.71 -284.2,75.7 -284.2,75.7 ;M-283.92 75.71 C-283.92,75.71 -284.2,75.7 -284.2,75.7 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-431.97 75.71 C-431.97,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -284.2,75.7 -284.2,75.7 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-431.97 75.71 C-431.97,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -284.2,75.7 -284.2,75.7 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-431.97 75.71 C-431.97,75.71 -432.5,75.71 -432.5,75.71 ;M-431.97 75.71 C-431.97,75.71 -432.5,75.71 -432.5,75.71 '
          keySplines='0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0'
          calcMode='spline'
        />
        <animate
          repeatCount={repeatCount}
          dur='5.5s'
          begin='0s'
          xlinkHref='#_R_G_L_21_G_M'
          fill='freeze'
          attributeName='opacity'
          from='0'
          to='0'
          keyTimes='0;0.2727273;0.272728;0.3636364;0.3636364;1'
          values='0;0;1;1;0;0'
          keySplines='0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0'
          calcMode='spline'
        />
        <animate
          repeatCount={repeatCount}
          dur='5.5s'
          begin='0s'
          xlinkHref='#_R_G_L_20_G_D_0_P_0'
          fill='freeze'
          attributeName='d'
          attributeType='XML'
          from='M-283.92 75.71 C-283.92,75.71 -284.04,75.7 -284.04,75.7 '
          to='M-431.94 75.65 C-431.94,75.65 -432.5,75.71 -432.5,75.71 '
          keyTimes='0;0.2727273;0.3030303;0.3257576;0.3560606;0.4318182;0.4621212;0.4848485;0.5151515;0.5984848;0.6287879;0.6515152;0.6818182;1'
          values='M-283.92 75.71 C-283.92,75.71 -284.04,75.7 -284.04,75.7 ;M-283.92 75.71 C-283.92,75.71 -284.04,75.7 -284.04,75.7 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-431.94 75.65 C-431.94,75.65 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -284.04,75.7 -284.04,75.7 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-431.94 75.65 C-431.94,75.65 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -284.04,75.7 -284.04,75.7 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-431.94 75.65 C-431.94,75.65 -432.5,75.71 -432.5,75.71 ;M-431.94 75.65 C-431.94,75.65 -432.5,75.71 -432.5,75.71 '
          keySplines='0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0'
          calcMode='spline'
        />
        <animate
          repeatCount={repeatCount}
          dur='5.5s'
          begin='0s'
          xlinkHref='#_R_G_L_20_G_M'
          fill='freeze'
          attributeName='opacity'
          from='0'
          to='0'
          keyTimes='0;0.2727273;0.272728;0.3636364;0.3636364;1'
          values='0;0;1;1;0;0'
          keySplines='0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0'
          calcMode='spline'
        />
        <animate
          repeatCount={repeatCount}
          dur='5.5s'
          begin='0s'
          xlinkHref='#_R_G_L_19_G_D_0_P_0'
          fill='freeze'
          attributeName='d'
          attributeType='XML'
          from='M-283.92 75.71 C-283.92,75.71 -284.04,75.7 -284.04,75.7 '
          to='M-431.94 75.65 C-431.94,75.65 -432.5,75.71 -432.5,75.71 '
          keyTimes='0;0.2727273;0.3030303;0.3257576;0.3560606;0.4318182;0.4621212;0.4848485;0.5151515;0.5984848;0.6287879;0.6515152;0.6818182;1'
          values='M-283.92 75.71 C-283.92,75.71 -284.04,75.7 -284.04,75.7 ;M-283.92 75.71 C-283.92,75.71 -284.04,75.7 -284.04,75.7 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-431.94 75.65 C-431.94,75.65 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -284.04,75.7 -284.04,75.7 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-431.94 75.65 C-431.94,75.65 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -284.04,75.7 -284.04,75.7 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-431.94 75.65 C-431.94,75.65 -432.5,75.71 -432.5,75.71 ;M-431.94 75.65 C-431.94,75.65 -432.5,75.71 -432.5,75.71 '
          keySplines='0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0'
          calcMode='spline'
        />
        <animate
          repeatCount={repeatCount}
          dur='5.5s'
          begin='0s'
          xlinkHref='#_R_G_L_19_G_M'
          fill='freeze'
          attributeName='opacity'
          from='0'
          to='0'
          keyTimes='0;0.2727273;0.272728;0.3636364;0.3636364;1'
          values='0;0;1;1;0;0'
          keySplines='0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0'
          calcMode='spline'
        />
        <animate
          repeatCount={repeatCount}
          dur='5.5s'
          begin='0s'
          xlinkHref='#_R_G_L_18_G_D_0_P_0'
          fill='freeze'
          attributeName='d'
          attributeType='XML'
          from='M-283.92 75.71 C-283.92,75.71 -284.2,75.68 -284.2,75.68 '
          to='M-432.65 75.71 C-432.65,75.71 -432.5,75.71 -432.5,75.71 '
          keyTimes='0;0.2727273;0.3030303;0.3257576;0.3560606;0.4318182;0.4621212;0.4848485;0.5151515;0.5984848;0.6287879;0.6515152;0.6818182;1'
          values='M-283.92 75.71 C-283.92,75.71 -284.2,75.68 -284.2,75.68 ;M-283.92 75.71 C-283.92,75.71 -284.2,75.68 -284.2,75.68 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-432.65 75.71 C-432.65,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -284.2,75.68 -284.2,75.68 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-432.65 75.71 C-432.65,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -284.2,75.68 -284.2,75.68 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-432.65 75.71 C-432.65,75.71 -432.5,75.71 -432.5,75.71 ;M-432.65 75.71 C-432.65,75.71 -432.5,75.71 -432.5,75.71 '
          keySplines='0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0'
          calcMode='spline'
        />
        <animate
          repeatCount={repeatCount}
          dur='5.5s'
          begin='0s'
          xlinkHref='#_R_G_L_18_G_M'
          fill='freeze'
          attributeName='opacity'
          from='0'
          to='0'
          keyTimes='0;0.4318182;0.4318189;0.5227273;0.5227273;1'
          values='0;0;1;1;0;0'
          keySplines='0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0'
          calcMode='spline'
        />
        <animate
          repeatCount={repeatCount}
          dur='5.5s'
          begin='0s'
          xlinkHref='#_R_G_L_17_G_D_0_P_0'
          fill='freeze'
          attributeName='d'
          attributeType='XML'
          from='M-283.92 75.71 C-283.92,75.71 -284.2,75.68 -284.2,75.68 '
          to='M-432.65 75.71 C-432.65,75.71 -432.5,75.71 -432.5,75.71 '
          keyTimes='0;0.2727273;0.3030303;0.3257576;0.3560606;0.4318182;0.4621212;0.4848485;0.5151515;0.5984848;0.6287879;0.6515152;0.6818182;1'
          values='M-283.92 75.71 C-283.92,75.71 -284.2,75.68 -284.2,75.68 ;M-283.92 75.71 C-283.92,75.71 -284.2,75.68 -284.2,75.68 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-432.65 75.71 C-432.65,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -284.2,75.68 -284.2,75.68 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-432.65 75.71 C-432.65,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -284.2,75.68 -284.2,75.68 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-432.65 75.71 C-432.65,75.71 -432.5,75.71 -432.5,75.71 ;M-432.65 75.71 C-432.65,75.71 -432.5,75.71 -432.5,75.71 '
          keySplines='0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0'
          calcMode='spline'
        />
        <animate
          repeatCount={repeatCount}
          dur='5.5s'
          begin='0s'
          xlinkHref='#_R_G_L_17_G_M'
          fill='freeze'
          attributeName='opacity'
          from='0'
          to='0'
          keyTimes='0;0.4318182;0.4318189;0.5227273;0.5227273;1'
          values='0;0;1;1;0;0'
          keySplines='0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0'
          calcMode='spline'
        />
        <animate
          repeatCount={repeatCount}
          dur='5.5s'
          begin='0s'
          xlinkHref='#_R_G_L_16_G_D_0_P_0'
          fill='freeze'
          attributeName='d'
          attributeType='XML'
          from='M-283.92 75.71 C-283.92,75.71 -284.2,75.7 -284.2,75.7 '
          to='M-431.97 75.71 C-431.97,75.71 -432.5,75.71 -432.5,75.71 '
          keyTimes='0;0.2727273;0.3030303;0.3257576;0.3560606;0.4318182;0.4621212;0.4848485;0.5151515;0.5984848;0.6287879;0.6515152;0.6818182;1'
          values='M-283.92 75.71 C-283.92,75.71 -284.2,75.7 -284.2,75.7 ;M-283.92 75.71 C-283.92,75.71 -284.2,75.7 -284.2,75.7 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-431.97 75.71 C-431.97,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -284.2,75.7 -284.2,75.7 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-431.97 75.71 C-431.97,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -284.2,75.7 -284.2,75.7 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-431.97 75.71 C-431.97,75.71 -432.5,75.71 -432.5,75.71 ;M-431.97 75.71 C-431.97,75.71 -432.5,75.71 -432.5,75.71 '
          keySplines='0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0'
          calcMode='spline'
        />
        <animate
          repeatCount={repeatCount}
          dur='5.5s'
          begin='0s'
          xlinkHref='#_R_G_L_16_G_M'
          fill='freeze'
          attributeName='opacity'
          from='0'
          to='0'
          keyTimes='0;0.4318182;0.4318189;0.5227273;0.5227273;1'
          values='0;0;1;1;0;0'
          keySplines='0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0'
          calcMode='spline'
        />
        <animate
          repeatCount={repeatCount}
          dur='5.5s'
          begin='0s'
          xlinkHref='#_R_G_L_15_G_D_0_P_0'
          fill='freeze'
          attributeName='d'
          attributeType='XML'
          from='M-283.92 75.71 C-283.92,75.71 -284.2,75.7 -284.2,75.7 '
          to='M-431.97 75.71 C-431.97,75.71 -432.5,75.71 -432.5,75.71 '
          keyTimes='0;0.2727273;0.3030303;0.3257576;0.3560606;0.4318182;0.4621212;0.4848485;0.5151515;0.5984848;0.6287879;0.6515152;0.6818182;1'
          values='M-283.92 75.71 C-283.92,75.71 -284.2,75.7 -284.2,75.7 ;M-283.92 75.71 C-283.92,75.71 -284.2,75.7 -284.2,75.7 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-431.97 75.71 C-431.97,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -284.2,75.7 -284.2,75.7 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-431.97 75.71 C-431.97,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -284.2,75.7 -284.2,75.7 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-431.97 75.71 C-431.97,75.71 -432.5,75.71 -432.5,75.71 ;M-431.97 75.71 C-431.97,75.71 -432.5,75.71 -432.5,75.71 '
          keySplines='0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0'
          calcMode='spline'
        />
        <animate
          repeatCount={repeatCount}
          dur='5.5s'
          begin='0s'
          xlinkHref='#_R_G_L_15_G_M'
          fill='freeze'
          attributeName='opacity'
          from='0'
          to='0'
          keyTimes='0;0.4318182;0.4318189;0.5227273;0.5227273;1'
          values='0;0;1;1;0;0'
          keySplines='0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0'
          calcMode='spline'
        />
        <animate
          repeatCount={repeatCount}
          dur='5.5s'
          begin='0s'
          xlinkHref='#_R_G_L_14_G_D_0_P_0'
          fill='freeze'
          attributeName='d'
          attributeType='XML'
          from='M-283.92 75.71 C-283.92,75.71 -284.04,75.7 -284.04,75.7 '
          to='M-431.94 75.65 C-431.94,75.65 -432.5,75.71 -432.5,75.71 '
          keyTimes='0;0.2727273;0.3030303;0.3257576;0.3560606;0.4318182;0.4621212;0.4848485;0.5151515;0.5984848;0.6287879;0.6515152;0.6818182;1'
          values='M-283.92 75.71 C-283.92,75.71 -284.04,75.7 -284.04,75.7 ;M-283.92 75.71 C-283.92,75.71 -284.04,75.7 -284.04,75.7 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-431.94 75.65 C-431.94,75.65 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -284.04,75.7 -284.04,75.7 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-431.94 75.65 C-431.94,75.65 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -284.04,75.7 -284.04,75.7 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-431.94 75.65 C-431.94,75.65 -432.5,75.71 -432.5,75.71 ;M-431.94 75.65 C-431.94,75.65 -432.5,75.71 -432.5,75.71 '
          keySplines='0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0'
          calcMode='spline'
        />
        <animate
          repeatCount={repeatCount}
          dur='5.5s'
          begin='0s'
          xlinkHref='#_R_G_L_14_G_M'
          fill='freeze'
          attributeName='opacity'
          from='0'
          to='0'
          keyTimes='0;0.4318182;0.4318189;0.5227273;0.5227273;1'
          values='0;0;1;1;0;0'
          keySplines='0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0'
          calcMode='spline'
        />
        <animate
          repeatCount={repeatCount}
          dur='5.5s'
          begin='0s'
          xlinkHref='#_R_G_L_13_G_D_0_P_0'
          fill='freeze'
          attributeName='d'
          attributeType='XML'
          from='M-283.92 75.71 C-283.92,75.71 -284.04,75.7 -284.04,75.7 '
          to='M-431.94 75.65 C-431.94,75.65 -432.5,75.71 -432.5,75.71 '
          keyTimes='0;0.2727273;0.3030303;0.3257576;0.3560606;0.4318182;0.4621212;0.4848485;0.5151515;0.5984848;0.6287879;0.6515152;0.6818182;1'
          values='M-283.92 75.71 C-283.92,75.71 -284.04,75.7 -284.04,75.7 ;M-283.92 75.71 C-283.92,75.71 -284.04,75.7 -284.04,75.7 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-431.94 75.65 C-431.94,75.65 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -284.04,75.7 -284.04,75.7 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-431.94 75.65 C-431.94,75.65 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -284.04,75.7 -284.04,75.7 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-431.94 75.65 C-431.94,75.65 -432.5,75.71 -432.5,75.71 ;M-431.94 75.65 C-431.94,75.65 -432.5,75.71 -432.5,75.71 '
          keySplines='0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0'
          calcMode='spline'
        />
        <animate
          repeatCount={repeatCount}
          dur='5.5s'
          begin='0s'
          xlinkHref='#_R_G_L_13_G_M'
          fill='freeze'
          attributeName='opacity'
          from='0'
          to='0'
          keyTimes='0;0.4318182;0.4318189;0.5227273;0.5227273;1'
          values='0;0;1;1;0;0'
          keySplines='0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0'
          calcMode='spline'
        />
        <animate
          repeatCount={repeatCount}
          dur='5.5s'
          begin='0s'
          xlinkHref='#_R_G_L_12_G_D_0_P_0'
          fill='freeze'
          attributeName='d'
          attributeType='XML'
          from='M-283.92 75.71 C-283.92,75.71 -284.2,75.68 -284.2,75.68 '
          to='M-432.65 75.71 C-432.65,75.71 -432.5,75.71 -432.5,75.71 '
          keyTimes='0;0.2727273;0.3030303;0.3257576;0.3560606;0.4318182;0.4621212;0.4848485;0.5151515;0.5984848;0.6287879;0.6515152;0.6818182;1'
          values='M-283.92 75.71 C-283.92,75.71 -284.2,75.68 -284.2,75.68 ;M-283.92 75.71 C-283.92,75.71 -284.2,75.68 -284.2,75.68 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-432.65 75.71 C-432.65,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -284.2,75.68 -284.2,75.68 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-432.65 75.71 C-432.65,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -284.2,75.68 -284.2,75.68 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-432.65 75.71 C-432.65,75.71 -432.5,75.71 -432.5,75.71 ;M-432.65 75.71 C-432.65,75.71 -432.5,75.71 -432.5,75.71 '
          keySplines='0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0'
          calcMode='spline'
        />
        <animate
          repeatCount={repeatCount}
          dur='5.5s'
          begin='0s'
          xlinkHref='#_R_G_L_12_G_M'
          fill='freeze'
          attributeName='opacity'
          from='0'
          to='0'
          keyTimes='0;0.5984848;0.5984856;0.6893939;0.6893939;1'
          values='0;0;1;1;0;0'
          keySplines='0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0'
          calcMode='spline'
        />
        <animate
          repeatCount={repeatCount}
          dur='5.5s'
          begin='0s'
          xlinkHref='#_R_G_L_11_G_D_0_P_0'
          fill='freeze'
          attributeName='d'
          attributeType='XML'
          from='M-283.92 75.71 C-283.92,75.71 -284.2,75.68 -284.2,75.68 '
          to='M-432.65 75.71 C-432.65,75.71 -432.5,75.71 -432.5,75.71 '
          keyTimes='0;0.2727273;0.3030303;0.3257576;0.3560606;0.4318182;0.4621212;0.4848485;0.5151515;0.5984848;0.6287879;0.6515152;0.6818182;1'
          values='M-283.92 75.71 C-283.92,75.71 -284.2,75.68 -284.2,75.68 ;M-283.92 75.71 C-283.92,75.71 -284.2,75.68 -284.2,75.68 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-432.65 75.71 C-432.65,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -284.2,75.68 -284.2,75.68 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-432.65 75.71 C-432.65,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -284.2,75.68 -284.2,75.68 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-432.65 75.71 C-432.65,75.71 -432.5,75.71 -432.5,75.71 ;M-432.65 75.71 C-432.65,75.71 -432.5,75.71 -432.5,75.71 '
          keySplines='0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0'
          calcMode='spline'
        />
        <animate
          repeatCount={repeatCount}
          dur='5.5s'
          begin='0s'
          xlinkHref='#_R_G_L_11_G_M'
          fill='freeze'
          attributeName='opacity'
          from='0'
          to='0'
          keyTimes='0;0.5984848;0.5984856;0.6893939;0.6893939;1'
          values='0;0;1;1;0;0'
          keySplines='0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0'
          calcMode='spline'
        />
        <animate
          repeatCount={repeatCount}
          dur='5.5s'
          begin='0s'
          xlinkHref='#_R_G_L_10_G_D_0_P_0'
          fill='freeze'
          attributeName='d'
          attributeType='XML'
          from='M-283.92 75.71 C-283.92,75.71 -284.2,75.7 -284.2,75.7 '
          to='M-431.97 75.71 C-431.97,75.71 -432.5,75.71 -432.5,75.71 '
          keyTimes='0;0.2727273;0.3030303;0.3257576;0.3560606;0.4318182;0.4621212;0.4848485;0.5151515;0.5984848;0.6287879;0.6515152;0.6818182;1'
          values='M-283.92 75.71 C-283.92,75.71 -284.2,75.7 -284.2,75.7 ;M-283.92 75.71 C-283.92,75.71 -284.2,75.7 -284.2,75.7 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-431.97 75.71 C-431.97,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -284.2,75.7 -284.2,75.7 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-431.97 75.71 C-431.97,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -284.2,75.7 -284.2,75.7 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-431.97 75.71 C-431.97,75.71 -432.5,75.71 -432.5,75.71 ;M-431.97 75.71 C-431.97,75.71 -432.5,75.71 -432.5,75.71 '
          keySplines='0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0'
          calcMode='spline'
        />
        <animate
          repeatCount={repeatCount}
          dur='5.5s'
          begin='0s'
          xlinkHref='#_R_G_L_10_G_M'
          fill='freeze'
          attributeName='opacity'
          from='0'
          to='0'
          keyTimes='0;0.5984848;0.5984856;0.6893939;0.6893939;1'
          values='0;0;1;1;0;0'
          keySplines='0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0'
          calcMode='spline'
        />
        <animate
          repeatCount={repeatCount}
          dur='5.5s'
          begin='0s'
          xlinkHref='#_R_G_L_9_G_D_0_P_0'
          fill='freeze'
          attributeName='d'
          attributeType='XML'
          from='M-283.92 75.71 C-283.92,75.71 -284.2,75.7 -284.2,75.7 '
          to='M-431.97 75.71 C-431.97,75.71 -432.5,75.71 -432.5,75.71 '
          keyTimes='0;0.2727273;0.3030303;0.3257576;0.3560606;0.4318182;0.4621212;0.4848485;0.5151515;0.5984848;0.6287879;0.6515152;0.6818182;1'
          values='M-283.92 75.71 C-283.92,75.71 -284.2,75.7 -284.2,75.7 ;M-283.92 75.71 C-283.92,75.71 -284.2,75.7 -284.2,75.7 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-431.97 75.71 C-431.97,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -284.2,75.7 -284.2,75.7 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-431.97 75.71 C-431.97,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -284.2,75.7 -284.2,75.7 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-431.97 75.71 C-431.97,75.71 -432.5,75.71 -432.5,75.71 ;M-431.97 75.71 C-431.97,75.71 -432.5,75.71 -432.5,75.71 '
          keySplines='0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0'
          calcMode='spline'
        />
        <animate
          repeatCount={repeatCount}
          dur='5.5s'
          begin='0s'
          xlinkHref='#_R_G_L_9_G_M'
          fill='freeze'
          attributeName='opacity'
          from='0'
          to='0'
          keyTimes='0;0.5984848;0.5984856;0.6893939;0.6893939;1'
          values='0;0;1;1;0;0'
          keySplines='0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0'
          calcMode='spline'
        />
        <animate
          repeatCount={repeatCount}
          dur='5.5s'
          begin='0s'
          xlinkHref='#_R_G_L_8_G_D_0_P_0'
          fill='freeze'
          attributeName='d'
          attributeType='XML'
          from='M-283.92 75.71 C-283.92,75.71 -284.04,75.7 -284.04,75.7 '
          to='M-431.94 75.65 C-431.94,75.65 -432.5,75.71 -432.5,75.71 '
          keyTimes='0;0.2727273;0.3030303;0.3257576;0.3560606;0.4318182;0.4621212;0.4848485;0.5151515;0.5984848;0.6287879;0.6515152;0.6818182;1'
          values='M-283.92 75.71 C-283.92,75.71 -284.04,75.7 -284.04,75.7 ;M-283.92 75.71 C-283.92,75.71 -284.04,75.7 -284.04,75.7 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-431.94 75.65 C-431.94,75.65 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -284.04,75.7 -284.04,75.7 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-431.94 75.65 C-431.94,75.65 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -284.04,75.7 -284.04,75.7 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-431.94 75.65 C-431.94,75.65 -432.5,75.71 -432.5,75.71 ;M-431.94 75.65 C-431.94,75.65 -432.5,75.71 -432.5,75.71 '
          keySplines='0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0'
          calcMode='spline'
        />
        <animate
          repeatCount={repeatCount}
          dur='5.5s'
          begin='0s'
          xlinkHref='#_R_G_L_8_G_M'
          fill='freeze'
          attributeName='opacity'
          from='0'
          to='0'
          keyTimes='0;0.5984848;0.5984856;0.6893939;0.6893939;1'
          values='0;0;1;1;0;0'
          keySplines='0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0'
          calcMode='spline'
        />
        <animate
          repeatCount={repeatCount}
          dur='5.5s'
          begin='0s'
          xlinkHref='#_R_G_L_7_G_D_0_P_0'
          fill='freeze'
          attributeName='d'
          attributeType='XML'
          from='M-283.92 75.71 C-283.92,75.71 -284.04,75.7 -284.04,75.7 '
          to='M-431.94 75.65 C-431.94,75.65 -432.5,75.71 -432.5,75.71 '
          keyTimes='0;0.2727273;0.3030303;0.3257576;0.3560606;0.4318182;0.4621212;0.4848485;0.5151515;0.5984848;0.6287879;0.6515152;0.6818182;1'
          values='M-283.92 75.71 C-283.92,75.71 -284.04,75.7 -284.04,75.7 ;M-283.92 75.71 C-283.92,75.71 -284.04,75.7 -284.04,75.7 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-431.94 75.65 C-431.94,75.65 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -284.04,75.7 -284.04,75.7 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-431.94 75.65 C-431.94,75.65 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -284.04,75.7 -284.04,75.7 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-283.92 75.71 C-283.92,75.71 -432.5,75.71 -432.5,75.71 ;M-431.94 75.65 C-431.94,75.65 -432.5,75.71 -432.5,75.71 ;M-431.94 75.65 C-431.94,75.65 -432.5,75.71 -432.5,75.71 '
          keySplines='0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0'
          calcMode='spline'
        />
        <animate
          repeatCount={repeatCount}
          dur='5.5s'
          begin='0s'
          xlinkHref='#_R_G_L_7_G_M'
          fill='freeze'
          attributeName='opacity'
          from='0'
          to='0'
          keyTimes='0;0.5984848;0.5984856;0.6893939;0.6893939;1'
          values='0;0;1;1;0;0'
          keySplines='0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0'
          calcMode='spline'
        />
        <animate
          repeatCount={repeatCount}
          dur='5.5s'
          begin='0s'
          xlinkHref='#_R_G_L_6_G_D_0_P_0'
          fill='freeze'
          attributeName='d'
          attributeType='XML'
          from='M-124.52 -18 C-130.72,-10.99 -133.34,-17.95 -140.01,-4.01 C-123.28,-17.36 -126.07,-14.81 -126.07,-14.81 C-126.07,-14.81 -129.11,-7.26 -132.37,-1.19 C-127.68,-4.39 -122.27,-8.27 -120.08,-10.97 C-112.02,-20.94 -112.94,-17.84 -110.98,-22.93 C-112.22,-36.26 -121.31,-31 -123.08,-29.19 C-125.85,-27.41 -135.04,-15.72 -138.62,-7.08 C-128.24,-18.24 -130.06,-13.88 -124.52,-18z '
          to='M232.22 279.43 C234.82,275.52 235.52,274.82 226.3,273.22 C8.65,318.93 -54.69,185.16 -54.69,185.16 C-54.69,185.16 -54.13,185.38 -53.07,185.73 C-52.4,185.95 -51.53,186.23 -50.46,186.55 C-28.1,193.17 78.19,215.74 153.02,75.23 C184,-83 113.12,-129.08 34.73,-156.39 C-43.65,-183.7 -192.95,-156.48 -227.49,35.54 C-264.87,243.27 -39.5,411 232.22,279.43z '
          keyTimes='0;0.030303;0.0378788;0.0530303;0.0606061;0.0681818;0.0757576;0.0833333;0.0909091;0.0984848;0.1060606;0.1136364;0.1212121;0.1287879;1'
          values='M-124.52 -18 C-130.72,-10.99 -133.34,-17.95 -140.01,-4.01 C-123.28,-17.36 -126.07,-14.81 -126.07,-14.81 C-126.07,-14.81 -129.11,-7.26 -132.37,-1.19 C-127.68,-4.39 -122.27,-8.27 -120.08,-10.97 C-112.02,-20.94 -112.94,-17.84 -110.98,-22.93 C-112.22,-36.26 -121.31,-31 -123.08,-29.19 C-125.85,-27.41 -135.04,-15.72 -138.62,-7.08 C-128.24,-18.24 -130.06,-13.88 -124.52,-18z ;M-124.52 -18 C-130.72,-10.99 -133.34,-17.95 -140.01,-4.01 C-123.28,-17.36 -126.07,-14.81 -126.07,-14.81 C-126.07,-14.81 -129.11,-7.26 -132.37,-1.19 C-127.68,-4.39 -122.27,-8.27 -120.08,-10.97 C-112.02,-20.94 -112.94,-17.84 -110.98,-22.93 C-112.22,-36.26 -121.31,-31 -123.08,-29.19 C-125.85,-27.41 -135.04,-15.72 -138.62,-7.08 C-128.24,-18.24 -130.06,-13.88 -124.52,-18z ;M-120.46 -30.92 C-126.66,-23.9 -132.58,-16.8 -139.24,-2.85 C-122.51,-16.21 -113.44,-26.51 -113.44,-26.51 C-113.44,-26.51 -116.85,-27.04 -135.09,-1.47 C-115.38,-7.18 -107.48,-12.84 -104.53,-15.03 C-97.59,-20.21 -99.46,-18.52 -89.21,-31.78 C-84.03,-46.66 -85.02,-63.17 -107.05,-60.29 C-130.46,-53.47 -134,-33.5 -139,-9.19 C-128.63,-20.35 -137,-6 -120.46,-30.92z ;M-95.96 -73.92 C-101.19,-62.5 -108.48,-57.36 -111.6,-42.59 C-90.47,-52.64 -77.44,-64.01 -77.44,-64.01 C-77.44,-64.01 -81.47,-51.35 -99.71,-25.79 C-81.04,-25.62 -57.48,-44.84 -54.53,-47.03 C-47.59,-52.21 -36.44,-60.36 -26.18,-73.63 C-7.7,-113.97 -30.43,-128.55 -59.34,-123.79 C-82.75,-116.97 -94.33,-112.25 -125.5,-54.69 C-115.78,-57.79 -118.78,-53.93 -95.96,-73.92z ;M-26.48 -138.25 C-41.27,-129.04 -58.03,-116.75 -68.71,-103.49 C-45.89,-106.23 -29.83,-101.75 -29.83,-101.75 C-29.83,-101.75 -55.84,-91.81 -67.97,-69.53 C-44.66,-69.38 -30.51,-69.78 -33.95,-68.48 C-44.86,-64.34 -56.59,-59.93 -66.5,-42.75 C29.14,-58.63 41.28,-66.72 47.02,-114.35 C47.75,-162.22 2.43,-200.25 -82.61,-134.89 C-55.59,-136.14 -42.02,-141.76 -26.48,-138.25z ;M30.98 -158.48 C10.83,-156.36 7.84,-157.48 -35.77,-140.05 C-3.79,-139.44 30.86,-131.7 30.86,-131.7 C30.86,-131.7 -10.77,-127.8 -36.41,-103.52 C-13.1,-103.37 5.91,-98.91 2.47,-97.61 C-8.45,-93.47 -27.65,-87.66 -45.45,-61.36 C111.42,-69.62 132.94,28.13 196.74,-55.27 C240.01,-149.02 84.07,-223.23 -30.82,-163.22 C-3.79,-164.46 15.44,-162 30.98,-158.48z ;M30.98 -158.48 C10.83,-156.36 7.84,-157.48 -35.77,-140.05 C-3.79,-139.44 30.86,-131.7 30.86,-131.7 C30.86,-131.7 -10.77,-127.8 -36.41,-103.52 C-13.1,-103.37 5.91,-98.91 2.47,-97.61 C-8.45,-93.47 -27.65,-87.66 -45.45,-61.36 C111.42,-69.62 132.94,28.13 196.74,-55.27 C240.01,-149.02 84.07,-223.23 -30.82,-163.22 C-3.79,-164.46 15.44,-162 30.98,-158.48z ;M142.78 -162.74 C151.15,-155.14 173.28,-148.73 196.76,-118.52 C168.63,-140 108.25,-159.84 108.25,-159.84 C108.25,-159.84 119.12,-152.23 158.79,-121.49 C124.94,-135.92 75.31,-146.88 78.52,-145.07 C145.37,-107.49 201.99,-73.78 186.23,16.35 C171.92,98.2 108.4,144.62 198.12,204.02 C327.95,255.55 350.69,81.92 338.79,42.77 C289.94,-118.04 173.28,-159.8 142.78,-162.74z ;M268.37 -77.97 C279.88,-56.29 294.11,-40.39 298.69,-10.78 C287.41,-44.58 243.37,-72.48 243.37,-72.48 C243.37,-72.48 266.65,-36.88 267.12,-6.76 C246.4,-49.59 229.44,-63.16 231.11,-59.88 C261.49,-0.35 245.73,90.83 164.28,134.21 C72.37,183.16 -22.08,124.26 -26.2,267.05 C-29.04,365.49 191.28,363.82 308.67,211.32 C363.56,140.01 352.33,-3.86 268.37,-77.97z ;M338.68 65.99 C335.73,87.89 336.11,81.35 330.49,101.38 C329.96,80.59 324.62,58.05 324.62,58.05 C324.62,58.05 324.58,59.06 324.44,60.92 C324.35,62.11 324.22,63.63 324.05,65.47 C320.33,104.09 294.16,279.48 125.93,258.83 C-36.39,238.89 6.16,-41.53 -173.02,52.77 C-278.34,108.2 -184.11,329.48 38.11,333.45 C117.06,334.86 360.15,303.69 338.68,65.99z ;M338.68 65.99 C335.73,87.89 336.11,81.35 330.49,101.38 C329.96,80.59 324.62,58.05 324.62,58.05 C324.62,58.05 324.58,59.06 324.44,60.92 C324.35,62.11 324.22,63.63 324.05,65.47 C320.33,104.09 294.16,279.48 125.93,258.83 C-36.39,238.89 6.16,-41.53 -173.02,52.77 C-278.34,108.2 -184.11,329.48 38.11,333.45 C117.06,334.86 360.15,303.69 338.68,65.99z ;M236.72 279.93 C239.32,276.02 203.48,282.14 194.25,280.54 C223.54,260.12 222.44,255.6 222.44,255.6 C222.44,255.6 221.11,255.77 218.66,256.04 C217.1,256.21 215.1,256.42 212.69,256.65 C162.16,261.45 -64.92,275.38 6.72,128.65 C9.11,-30.95 -72.17,-56.49 -151.05,-47.24 C-233.49,-37.58 -309.16,102.27 -167.89,241.45 C-35.01,372.36 100.46,337.52 236.72,279.93z ;M232.22 279.43 C234.82,275.52 235.52,274.82 226.3,273.22 C8.65,318.93 -54.69,185.16 -54.69,185.16 C-54.69,185.16 -54.13,185.38 -53.07,185.73 C-52.4,185.95 -51.53,186.23 -50.46,186.55 C-28.1,193.17 78.19,215.74 153.02,75.23 C184,-83 113.12,-129.08 34.73,-156.39 C-43.65,-183.7 -192.95,-156.48 -227.49,35.54 C-264.87,243.27 -39.5,411 232.22,279.43z ;M232.22 279.43 C234.82,275.52 235.52,274.82 226.3,273.22 C8.65,318.93 -54.69,185.16 -54.69,185.16 C-54.69,185.16 -54.13,185.38 -53.07,185.73 C-52.4,185.95 -51.53,186.23 -50.46,186.55 C-28.1,193.17 78.19,215.74 153.02,75.23 C184,-83 113.12,-129.08 34.73,-156.39 C-43.65,-183.7 -192.95,-156.48 -227.49,35.54 C-264.87,243.27 -39.5,411 232.22,279.43z ;M232.22 279.43 C234.82,275.52 235.52,274.82 226.3,273.22 C8.65,318.93 -54.69,185.16 -54.69,185.16 C-54.69,185.16 -54.13,185.38 -53.07,185.73 C-52.4,185.95 -51.53,186.23 -50.46,186.55 C-28.1,193.17 78.19,215.74 153.02,75.23 C184,-83 113.12,-129.08 34.73,-156.39 C-43.65,-183.7 -192.95,-156.48 -227.49,35.54 C-264.87,243.27 -39.5,411 232.22,279.43z '
          keySplines='0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0'
          calcMode='spline'
        />
        <animate
          repeatCount={repeatCount}
          dur='5.5s'
          begin='0s'
          xlinkHref='#_R_G_L_6_G_M'
          fill='freeze'
          attributeName='opacity'
          from='0'
          to='0'
          keyTimes='0;0.030303;0.0303038;0.1363636;0.1363636;1'
          values='0;0;1;1;0;0'
          keySplines='0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0'
          calcMode='spline'
        />
        <animate
          repeatCount={repeatCount}
          dur='5.5s'
          begin='0s'
          xlinkHref='#_R_G_L_5_G_M'
          fill='freeze'
          attributeName='opacity'
          from='0'
          to='1'
          keyTimes='0;0.1287879;0.1287886;1'
          values='0;0;1;1'
          keySplines='0 0 0 0;0 0 0 0;0 0 0 0'
          calcMode='spline'
        />
        <animate
          repeatCount={repeatCount}
          dur='5.5s'
          begin='0s'
          xlinkHref='#_R_G_L_4_C_0_P_0'
          fill='freeze'
          attributeName='d'
          attributeType='XML'
          from='M-86.59 -63.09 C-86.59,-63.09 -161.21,-3.88 -161.21,-3.88 C-161.21,-3.88 -139.27,-11.2 -139.27,-11.2 C-139.27,-11.2 -106.64,-45.51 -106.64,-45.51 C-106.64,-45.51 -107.88,-47.8 -107.88,-47.8 C-107.88,-47.8 -106.66,-65.78 -106.66,-65.78 C-106.66,-65.78 -86.59,-63.09 -86.59,-63.09z '
          to='M-86.59 -63.09 C-86.59,-63.09 -161.21,-3.88 -161.21,-3.88 C-161.21,-3.88 -35.9,113.6 -35.9,113.6 C-35.9,113.6 155.47,-60.64 155.47,-60.64 C155.47,-60.64 110.19,-111.56 110.19,-111.56 C110.19,-111.56 -34.72,22.4 -34.72,22.4 C-34.72,22.4 -86.59,-63.09 -86.59,-63.09z '
          keyTimes='0;0.1515152;0.1590909;0.1742424;0.1893939;0.2121212;1'
          values='M-86.59 -63.09 C-86.59,-63.09 -161.21,-3.88 -161.21,-3.88 C-161.21,-3.88 -139.27,-11.2 -139.27,-11.2 C-139.27,-11.2 -106.64,-45.51 -106.64,-45.51 C-106.64,-45.51 -107.88,-47.8 -107.88,-47.8 C-107.88,-47.8 -106.66,-65.78 -106.66,-65.78 C-106.66,-65.78 -86.59,-63.09 -86.59,-63.09z ;M-86.59 -63.09 C-86.59,-63.09 -161.21,-3.88 -161.21,-3.88 C-161.21,-3.88 -139.27,-11.2 -139.27,-11.2 C-139.27,-11.2 -106.64,-45.51 -106.64,-45.51 C-106.64,-45.51 -107.88,-47.8 -107.88,-47.8 C-107.88,-47.8 -106.66,-65.78 -106.66,-65.78 C-106.66,-65.78 -86.59,-63.09 -86.59,-63.09z ;M-86.59 -63.09 C-86.59,-63.09 -161.21,-3.88 -161.21,-3.88 C-161.21,-3.88 -67.33,76.98 -67.33,76.98 C-67.33,76.98 -34.69,42.67 -34.69,42.67 C-34.69,42.67 -35.93,40.38 -35.93,40.38 C-35.93,40.38 -34.72,22.4 -34.72,22.4 C-34.72,22.4 -86.59,-63.09 -86.59,-63.09z ;M-86.59 -63.09 C-86.59,-63.09 -161.21,-3.88 -161.21,-3.88 C-161.21,-3.88 -35.9,113.6 -35.9,113.6 C-35.9,113.6 -5.08,80.79 -5.08,80.79 C-5.08,80.79 -35.63,42.94 -35.63,42.94 C-35.63,42.94 -34.72,22.4 -34.72,22.4 C-34.72,22.4 -86.59,-63.09 -86.59,-63.09z ;M-86.59 -63.09 C-86.59,-63.09 -161.21,-3.88 -161.21,-3.88 C-161.21,-3.88 -35.9,113.6 -35.9,113.6 C-35.9,113.6 11.46,70.37 11.46,70.37 C11.46,70.37 -34,22.16 -34,22.16 C-34,22.16 -34.72,22.4 -34.72,22.4 C-34.72,22.4 -86.59,-63.09 -86.59,-63.09z ;M-86.59 -63.09 C-86.59,-63.09 -161.21,-3.88 -161.21,-3.88 C-161.21,-3.88 -35.9,113.6 -35.9,113.6 C-35.9,113.6 155.47,-60.64 155.47,-60.64 C155.47,-60.64 110.19,-111.56 110.19,-111.56 C110.19,-111.56 -34.72,22.4 -34.72,22.4 C-34.72,22.4 -86.59,-63.09 -86.59,-63.09z ;M-86.59 -63.09 C-86.59,-63.09 -161.21,-3.88 -161.21,-3.88 C-161.21,-3.88 -35.9,113.6 -35.9,113.6 C-35.9,113.6 155.47,-60.64 155.47,-60.64 C155.47,-60.64 110.19,-111.56 110.19,-111.56 C110.19,-111.56 -34.72,22.4 -34.72,22.4 C-34.72,22.4 -86.59,-63.09 -86.59,-63.09z '
          keySplines='0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0'
          calcMode='spline'
        />
        <clipPath id='_R_G_L_4_C_0'>
          <path id='_R_G_L_4_C_0_P_0' fillRule='nonzero' />
        </clipPath>
        <animate
          repeatCount={repeatCount}
          dur='5.5s'
          begin='0s'
          xlinkHref='#_R_G_L_3_G_D_0_P_0'
          fill='freeze'
          attributeName='d'
          attributeType='XML'
          from='M-139 -5 C-140.34,-6.42 -147.56,-1.37 -144.5,3 C-143.62,4.25 -136.87,-2.75 -139,-5z '
          to='M227.96 255.87 C233,261 253.5,242.5 249.37,239 C244.26,234.67 226.28,254.17 227.96,255.87z '
          keyTimes='0;0.0378788;0.0530303;0.0606061;0.0681818;0.0757576;0.0833333;0.0909091;0.0984848;0.1060606;0.1136364;1'
          values='M-139 -5 C-140.34,-6.42 -147.56,-1.37 -144.5,3 C-143.62,4.25 -136.87,-2.75 -139,-5z ;M-139 -5 C-140.34,-6.42 -147.56,-1.37 -144.5,3 C-143.62,4.25 -136.87,-2.75 -139,-5z ;M-139.37 -5.75 C-140.81,-7.07 -149.62,-0.68 -145.75,3 C-143.25,5.38 -136.25,-2.87 -139.37,-5.75z ;M-93.12 -28.5 C-94.28,-30.07 -110.46,-22.69 -107.5,-18.25 C-105.5,-15.25 -89.25,-23.25 -93.12,-28.5z ;M-85.12 -50 C-86.75,-55 -118.5,-45 -115.25,-36.5 C-112.91,-30.37 -81.64,-39.28 -85.12,-50z ;M-84.65 -49.05 C-88.22,-54.2 -119.18,-42.79 -114.09,-34.08 C-108.59,-26.09 -80.08,-41.97 -84.65,-49.05z ;M49.43 -138.52 C52.77,-142.59 29.57,-151.44 25.56,-143.27 C22.61,-137.24 45.81,-134.11 49.43,-138.52z ;M215.23 -92.9 C222.33,-97.4 205.89,-109.19 201.13,-102.94 C197.07,-97.6 212,-90.86 215.23,-92.9z ;M304.03 19.53 C306.29,18.29 301.88,10.55 299.79,12.7 C298.11,14.44 301.93,20.68 304.03,19.53z ;M304.28 20.77 C308.44,17.87 303.03,13.7 298.3,13.5 C296.37,15.37 301.36,22.86 304.28,20.77z ;M227.96 255.87 C233,261 253.5,242.5 249.37,239 C244.26,234.67 226.28,254.17 227.96,255.87z ;M227.96 255.87 C233,261 253.5,242.5 249.37,239 C244.26,234.67 226.28,254.17 227.96,255.87z '
          keySplines='0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0'
          calcMode='spline'
        />
        <animate
          repeatCount={repeatCount}
          dur='5.5s'
          begin='0s'
          xlinkHref='#_R_G_L_3_G_M'
          fill='freeze'
          attributeName='opacity'
          from='0'
          to='0'
          keyTimes='0;0.0378788;0.0378795;0.1136364;0.1136364;1'
          values='0;0;1;1;0;0'
          keySplines='0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0'
          calcMode='spline'
        />
        <animate
          repeatCount={repeatCount}
          dur='5.5s'
          begin='0s'
          xlinkHref='#_R_G_L_2_G_D_0_P_0'
          fill='freeze'
          attributeName='d'
          attributeType='XML'
          from='M-110.55 -33.78 C-113.33,-39.26 -127.11,-24.85 -125.25,-20.88 C-124.25,-18.75 -108,-28.75 -110.55,-33.78z '
          to='M319.5 43.75 C322,42 318.5,24.75 312.75,26 C306.88,27.28 318.68,44.32 319.5,43.75z '
          keyTimes='0;0.0530303;0.0606061;0.0681818;0.0757576;0.0833333;0.0909091;0.0984848;0.1060606;1'
          values='M-110.55 -33.78 C-113.33,-39.26 -127.11,-24.85 -125.25,-20.88 C-124.25,-18.75 -108,-28.75 -110.55,-33.78z ;M-110.55 -33.78 C-113.33,-39.26 -127.11,-24.85 -125.25,-20.88 C-124.25,-18.75 -108,-28.75 -110.55,-33.78z ;M-80.05 -67.78 C-82.14,-73.56 -99.61,-61.1 -97.75,-57.13 C-96.75,-55 -77.25,-60 -80.05,-67.78z ;M-63.77 -90.59 C-65.73,-96.41 -95.16,-85.22 -92.53,-79.09 C-90.89,-75.25 -61.21,-83.04 -63.77,-90.59z ;M-63.55 -91.78 C-65.4,-97.64 -95.15,-87.18 -91.75,-78.88 C-89.47,-73.32 -61.25,-84.46 -63.55,-91.78z ;M88.57 -158.24 C89.54,-161.13 71.16,-170.69 65.91,-163.19 C62.47,-158.27 86.48,-152.04 88.57,-158.24z ;M233.39 -69.63 C235.98,-71.25 228.36,-88.46 221.14,-85.58 C215.56,-83.35 229.62,-67.27 233.39,-69.63z ;M319.5 43.75 C322,42 318.5,24.75 312.75,26 C306.88,27.28 318.68,44.32 319.5,43.75z ;M319.5 43.75 C322,42 318.5,24.75 312.75,26 C306.88,27.28 318.68,44.32 319.5,43.75z ;M319.5 43.75 C322,42 318.5,24.75 312.75,26 C306.88,27.28 318.68,44.32 319.5,43.75z '
          keySplines='0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0'
          calcMode='spline'
        />
        <animate
          repeatCount={repeatCount}
          dur='5.5s'
          begin='0s'
          xlinkHref='#_R_G_L_2_G_M'
          fill='freeze'
          attributeName='opacity'
          from='0'
          to='0'
          keyTimes='0;0.0530303;0.0530311;0.1136364;0.1136364;1'
          values='0;0;1;1;0;0'
          keySplines='0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0'
          calcMode='spline'
        />
        <animate
          repeatCount={repeatCount}
          dur='5.5s'
          begin='0s'
          xlinkHref='#_R_G_L_1_G_D_0_P_0'
          fill='freeze'
          attributeName='d'
          attributeType='XML'
          from='M-133.79 -28.12 C-131.96,-24.68 -118.65,-40.81 -122.17,-43.9 C-126.05,-47.31 -136.23,-32.73 -133.79,-28.12z '
          to='M327.5 45.75 C325.25,46.75 328.5,63 331.88,58 C335.25,53 329.75,44.75 327.5,45.75z '
          keyTimes='0;0.0530303;0.0606061;0.0681818;0.0757576;0.0833333;0.0909091;0.1060606;1'
          values='M-133.79 -28.12 C-131.96,-24.68 -118.65,-40.81 -122.17,-43.9 C-126.05,-47.31 -136.23,-32.73 -133.79,-28.12z ;M-133.79 -28.12 C-131.96,-24.68 -118.65,-40.81 -122.17,-43.9 C-126.05,-47.31 -136.23,-32.73 -133.79,-28.12z ;M-86.57 -112.94 C-84.75,-109.5 -69.57,-119.32 -70.96,-122.13 C-73.25,-126.75 -89.01,-117.56 -86.57,-112.94z ;M-84.32 -135.94 C-80.25,-127.89 -57.98,-142.98 -59.46,-147.88 C-61.81,-155.67 -86.68,-140.6 -84.32,-135.94z ;M-84.32 -134.56 C-80.25,-126.5 -56.09,-140.08 -59.46,-147.88 C-62.75,-155.5 -86.68,-139.21 -84.32,-134.56z ;M109.18 -169.31 C107.38,-165.28 123.74,-158.95 125.79,-164.63 C127.14,-168.36 111.31,-174.07 109.18,-169.31z ;M241.87 -96.28 C238.76,-93.15 251.9,-78.38 255.27,-83.38 C258.65,-88.38 245.98,-100.4 241.87,-96.28z ;M327.5 45.75 C325.25,46.75 328.5,63 331.88,58 C335.25,53 329.75,44.75 327.5,45.75z ;M327.5 45.75 C325.25,46.75 328.5,63 331.88,58 C335.25,53 329.75,44.75 327.5,45.75z '
          keySplines='0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0'
          calcMode='spline'
        />
        <animate
          repeatCount={repeatCount}
          dur='5.5s'
          begin='0s'
          xlinkHref='#_R_G_L_1_G_M'
          fill='freeze'
          attributeName='opacity'
          from='0'
          to='0'
          keyTimes='0;0.0530303;0.0530311;0.1136364;0.1136364;1'
          values='0;0;1;1;0;0'
          keySplines='0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0'
          calcMode='spline'
        />
        <animate
          repeatCount={repeatCount}
          dur='5.5s'
          begin='0s'
          xlinkHref='#_R_G_L_0_G_D_0_P_0'
          fill='freeze'
          attributeName='d'
          attributeType='XML'
          from='M-105.7 -17.96 C-108.13,-19.96 -118.91,-11.85 -118.2,-11.14 C-115.84,-8.78 -103.17,-15.86 -105.7,-17.96z '
          to='M-36.87 -127.73 C-38.98,-132.73 -67.77,-124.8 -65.25,-117.87 C-62.74,-110.98 -33.96,-120.84 -36.87,-127.73z '
          keyTimes='0;0.0530303;0.0606061;0.0681818;1'
          values='M-105.7 -17.96 C-108.13,-19.96 -118.91,-11.85 -118.2,-11.14 C-115.84,-8.78 -103.17,-15.86 -105.7,-17.96z ;M-105.7 -17.96 C-108.13,-19.96 -118.91,-11.85 -118.2,-11.14 C-115.84,-8.78 -103.17,-15.86 -105.7,-17.96z ;M-75.62 -94.74 C-78.7,-97.99 -91.59,-87.69 -88.9,-84.25 C-86.39,-81.04 -72.25,-91.17 -75.62,-94.74z ;M-36.87 -127.73 C-38.98,-132.73 -67.77,-124.8 -65.25,-117.87 C-62.74,-110.98 -33.96,-120.84 -36.87,-127.73z ;M-36.87 -127.73 C-38.98,-132.73 -67.77,-124.8 -65.25,-117.87 C-62.74,-110.98 -33.96,-120.84 -36.87,-127.73z '
          keySplines='0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0'
          calcMode='spline'
        />
        <animate
          repeatCount={repeatCount}
          dur='5.5s'
          begin='0s'
          xlinkHref='#_R_G_L_0_G_M'
          fill='freeze'
          attributeName='opacity'
          from='0'
          to='0'
          keyTimes='0;0.0530303;0.0530311;0.0757576;0.0757576;1'
          values='0;0;1;1;0;0'
          keySplines='0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0'
          calcMode='spline'
        />
        <animate attributeType='XML' attributeName='opacity' dur='6s' from='0' to='1' xlinkHref='#time_group' />
      </defs>
      <g id='_R_G'>
        <g id='_R_G_L_24_G_M'>
          <g
            id='_R_G_L_24_G'
            transform=' translate(93.375, 71.533) scale(-0.09922, 0.09922) translate(282.652, -75.914)'
          >
            <path
              id='_R_G_L_24_G_D_0_P_0'
              stroke='#f1f95f'
              strokeLinecap='round'
              strokeLinejoin='round'
              fill='none'
              strokeWidth='34'
              strokeOpacity='1'
              d=' M-283.92 75.71 C-283.92,75.71 -284.2,75.68 -284.2,75.68 '
            />
          </g>
        </g>
        <g id='_R_G_L_23_G_M'>
          <g
            id='_R_G_L_23_G'
            transform=' translate(37.156, 62.342) rotate(-149.546) scale(-0.09922, 0.09922) translate(282.652, -75.914)'
          >
            <path
              id='_R_G_L_23_G_D_0_P_0'
              stroke='#f1f95f'
              strokeLinecap='round'
              strokeLinejoin='round'
              fill='none'
              strokeWidth='34'
              strokeOpacity='1'
              d=' M-283.92 75.71 C-283.92,75.71 -284.2,75.68 -284.2,75.68 '
            />
          </g>
        </g>
        <g id='_R_G_L_22_G_M'>
          <g id='_R_G_L_22_G' transform=' translate(35.822, 71.447) scale(0.09922, 0.09922) translate(283.983, -75.05)'>
            <path
              id='_R_G_L_22_G_D_0_P_0'
              stroke='#ceacf9'
              strokeLinecap='round'
              strokeLinejoin='round'
              fill='none'
              strokeWidth='34'
              strokeOpacity='1'
              d=' M-283.92 75.71 C-283.92,75.71 -284.2,75.7 -284.2,75.7 '
            />
          </g>
        </g>
        <g id='_R_G_L_21_G_M'>
          <g
            id='_R_G_L_21_G'
            transform=' translate(92.454, 79.761) rotate(-151.556) scale(0.09922, 0.09922) translate(283.983, -75.05)'
          >
            <path
              id='_R_G_L_21_G_D_0_P_0'
              stroke='#ceacf9'
              strokeLinecap='round'
              strokeLinejoin='round'
              fill='none'
              strokeWidth='34'
              strokeOpacity='1'
              d=' M-283.92 75.71 C-283.92,75.71 -284.2,75.7 -284.2,75.7 '
            />
          </g>
        </g>
        <g id='_R_G_L_20_G_M'>
          <g
            id='_R_G_L_20_G'
            transform=' translate(91.812, 63.714) rotate(149.583) scale(0.09922, 0.09922) translate(284.581, -77.595)'
          >
            <path
              id='_R_G_L_20_G_D_0_P_0'
              stroke='#6ce0fb'
              strokeLinecap='round'
              strokeLinejoin='round'
              fill='none'
              strokeWidth='34'
              strokeOpacity='1'
              d=' M-283.92 75.71 C-283.92,75.71 -284.04,75.7 -284.04,75.7 '
            />
          </g>
        </g>
        <g id='_R_G_L_19_G_M'>
          <g
            id='_R_G_L_19_G'
            transform=' translate(37.141, 80.619) rotate(-17.72) scale(0.09922, 0.09922) translate(284.581, -77.595)'
          >
            <path
              id='_R_G_L_19_G_D_0_P_0'
              stroke='#6ce0fb'
              strokeLinecap='round'
              strokeLinejoin='round'
              fill='none'
              strokeWidth='34'
              strokeOpacity='1'
              d=' M-283.92 75.71 C-283.92,75.71 -284.04,75.7 -284.04,75.7 '
            />
          </g>
        </g>
        <g id='_R_G_L_18_G_M'>
          <g
            id='_R_G_L_18_G'
            transform=' translate(93.375, 71.533) scale(-0.09922, 0.09922) translate(282.652, -75.914)'
          >
            <path
              id='_R_G_L_18_G_D_0_P_0'
              stroke='#f1f95f'
              strokeLinecap='round'
              strokeLinejoin='round'
              fill='none'
              strokeWidth='34'
              strokeOpacity='1'
              d=' M-283.92 75.71 C-283.92,75.71 -284.2,75.68 -284.2,75.68 '
            />
          </g>
        </g>
        <g id='_R_G_L_17_G_M'>
          <g
            id='_R_G_L_17_G'
            transform=' translate(37.156, 62.342) rotate(-149.546) scale(-0.09922, 0.09922) translate(282.652, -75.914)'
          >
            <path
              id='_R_G_L_17_G_D_0_P_0'
              stroke='#f1f95f'
              strokeLinecap='round'
              strokeLinejoin='round'
              fill='none'
              strokeWidth='34'
              strokeOpacity='1'
              d=' M-283.92 75.71 C-283.92,75.71 -284.2,75.68 -284.2,75.68 '
            />
          </g>
        </g>
        <g id='_R_G_L_16_G_M'>
          <g id='_R_G_L_16_G' transform=' translate(35.822, 71.447) scale(0.09922, 0.09922) translate(283.983, -75.05)'>
            <path
              id='_R_G_L_16_G_D_0_P_0'
              stroke='#ceacf9'
              strokeLinecap='round'
              strokeLinejoin='round'
              fill='none'
              strokeWidth='34'
              strokeOpacity='1'
              d=' M-283.92 75.71 C-283.92,75.71 -284.2,75.7 -284.2,75.7 '
            />
          </g>
        </g>
        <g id='_R_G_L_15_G_M'>
          <g
            id='_R_G_L_15_G'
            transform=' translate(92.454, 79.761) rotate(-151.556) scale(0.09922, 0.09922) translate(283.983, -75.05)'
          >
            <path
              id='_R_G_L_15_G_D_0_P_0'
              stroke='#ceacf9'
              strokeLinecap='round'
              strokeLinejoin='round'
              fill='none'
              strokeWidth='34'
              strokeOpacity='1'
              d=' M-283.92 75.71 C-283.92,75.71 -284.2,75.7 -284.2,75.7 '
            />
          </g>
        </g>
        <g id='_R_G_L_14_G_M'>
          <g
            id='_R_G_L_14_G'
            transform=' translate(91.812, 63.714) rotate(149.583) scale(0.09922, 0.09922) translate(284.581, -77.595)'
          >
            <path
              id='_R_G_L_14_G_D_0_P_0'
              stroke='#6ce0fb'
              strokeLinecap='round'
              strokeLinejoin='round'
              fill='none'
              strokeWidth='34'
              strokeOpacity='1'
              d=' M-283.92 75.71 C-283.92,75.71 -284.04,75.7 -284.04,75.7 '
            />
          </g>
        </g>
        <g id='_R_G_L_13_G_M'>
          <g
            id='_R_G_L_13_G'
            transform=' translate(37.141, 80.619) rotate(-17.72) scale(0.09922, 0.09922) translate(284.581, -77.595)'
          >
            <path
              id='_R_G_L_13_G_D_0_P_0'
              stroke='#6ce0fb'
              strokeLinecap='round'
              strokeLinejoin='round'
              fill='none'
              strokeWidth='34'
              strokeOpacity='1'
              d=' M-283.92 75.71 C-283.92,75.71 -284.04,75.7 -284.04,75.7 '
            />
          </g>
        </g>
        <g id='_R_G_L_12_G_M'>
          <g
            id='_R_G_L_12_G'
            transform=' translate(93.375, 71.533) scale(-0.09922, 0.09922) translate(282.652, -75.914)'
          >
            <path
              id='_R_G_L_12_G_D_0_P_0'
              stroke='#f1f95f'
              strokeLinecap='round'
              strokeLinejoin='round'
              fill='none'
              strokeWidth='34'
              strokeOpacity='1'
              d=' M-283.92 75.71 C-283.92,75.71 -284.2,75.68 -284.2,75.68 '
            />
          </g>
        </g>
        <g id='_R_G_L_11_G_M'>
          <g
            id='_R_G_L_11_G'
            transform=' translate(37.156, 62.342) rotate(-149.546) scale(-0.09922, 0.09922) translate(282.652, -75.914)'
          >
            <path
              id='_R_G_L_11_G_D_0_P_0'
              stroke='#f1f95f'
              strokeLinecap='round'
              strokeLinejoin='round'
              fill='none'
              strokeWidth='34'
              strokeOpacity='1'
              d=' M-283.92 75.71 C-283.92,75.71 -284.2,75.68 -284.2,75.68 '
            />
          </g>
        </g>
        <g id='_R_G_L_10_G_M'>
          <g id='_R_G_L_10_G' transform=' translate(35.822, 71.447) scale(0.09922, 0.09922) translate(283.983, -75.05)'>
            <path
              id='_R_G_L_10_G_D_0_P_0'
              stroke='#ceacf9'
              strokeLinecap='round'
              strokeLinejoin='round'
              fill='none'
              strokeWidth='34'
              strokeOpacity='1'
              d=' M-283.92 75.71 C-283.92,75.71 -284.2,75.7 -284.2,75.7 '
            />
          </g>
        </g>
        <g id='_R_G_L_9_G_M'>
          <g
            id='_R_G_L_9_G'
            transform=' translate(92.454, 79.761) rotate(-151.556) scale(0.09922, 0.09922) translate(283.983, -75.05)'
          >
            <path
              id='_R_G_L_9_G_D_0_P_0'
              stroke='#ceacf9'
              strokeLinecap='round'
              strokeLinejoin='round'
              fill='none'
              strokeWidth='34'
              strokeOpacity='1'
              d=' M-283.92 75.71 C-283.92,75.71 -284.2,75.7 -284.2,75.7 '
            />
          </g>
        </g>
        <g id='_R_G_L_8_G_M'>
          <g
            id='_R_G_L_8_G'
            transform=' translate(91.812, 63.714) rotate(149.583) scale(0.09922, 0.09922) translate(284.581, -77.595)'
          >
            <path
              id='_R_G_L_8_G_D_0_P_0'
              stroke='#6ce0fb'
              strokeLinecap='round'
              strokeLinejoin='round'
              fill='none'
              strokeWidth='34'
              strokeOpacity='1'
              d=' M-283.92 75.71 C-283.92,75.71 -284.04,75.7 -284.04,75.7 '
            />
          </g>
        </g>
        <g id='_R_G_L_7_G_M'>
          <g
            id='_R_G_L_7_G'
            transform=' translate(37.141, 80.619) rotate(-17.72) scale(0.09922, 0.09922) translate(284.581, -77.595)'
          >
            <path
              id='_R_G_L_7_G_D_0_P_0'
              stroke='#6ce0fb'
              strokeLinecap='round'
              strokeLinejoin='round'
              fill='none'
              strokeWidth='34'
              strokeOpacity='1'
              d=' M-283.92 75.71 C-283.92,75.71 -284.04,75.7 -284.04,75.7 '
            />
          </g>
        </g>
        <g id='_R_G_L_6_G_M'>
          <g id='_R_G_L_6_G' transform=' translate(64, 64) scale(0.09922, 0.09922) translate(0, 0)'>
            <path
              id='_R_G_L_6_G_D_0_P_0'
              fill='#00f4d7'
              fillOpacity='1'
              fillRule='nonzero'
              d=' M-124.52 -18 C-130.72,-10.99 -133.34,-17.95 -140.01,-4.01 C-123.28,-17.36 -126.07,-14.81 -126.07,-14.81 C-126.07,-14.81 -129.11,-7.26 -132.37,-1.19 C-127.68,-4.39 -122.27,-8.27 -120.08,-10.97 C-112.02,-20.94 -112.94,-17.84 -110.98,-22.93 C-112.22,-36.26 -121.31,-31 -123.08,-29.19 C-125.85,-27.41 -135.04,-15.72 -138.62,-7.08 C-128.24,-18.24 -130.06,-13.88 -124.52,-18z '
            />
          </g>
        </g>
        <g id='_R_G_L_5_G_M'>
          <g id='_R_G_L_5_G' transform=' translate(65.079, 71.455) scale(0.09924, 0.09924) translate(-12.542, -77.308)'>
            <path
              id='_R_G_L_5_G_D_0_P_0'
              fill='#00f4d7'
              fillOpacity='1'
              fillRule='nonzero'
              d=' M12.54 -165.11 C146.89,-165.11 255.96,-56.04 255.96,78.31 C255.96,212.65 146.89,321.73 12.54,321.73 C-121.8,321.73 -230.88,212.65 -230.88,78.31 C-230.88,-56.04 -121.8,-165.11 12.54,-165.11z '
            />
          </g>
        </g>
        <g id='_R_G_L_4_G' transform=' translate(65.192, 72.104) scale(0.128, 0.128) translate(0, 0)'>
          <g clipPath='url(#_R_G_L_4_C_0)'>
            <path
              id='_R_G_L_4_G_G_0_D_0_P_0'
              fill='#333333'
              fillOpacity='1'
              fillRule='nonzero'
              d=' M93.62 -30 C93.62,-30 132.51,-67.9 132.51,-67.9 C132.51,-67.9 114.13,-94.97 114.13,-94.97 C114.13,-94.97 70.48,-54.27 70.48,-54.27 C70.48,-54.27 9.94,2.17 9.94,2.17 C9.94,2.17 -20.33,30.39 -20.33,30.39 C-20.33,30.39 -35.46,44.5 -35.46,44.5 C-35.57,44.6 -35.55,44.59 -35.55,44.59 C-35.55,44.59 -35.55,44.62 -35.55,44.62 C-35.55,44.62 -35.54,44.65 -35.54,44.65 C-35.54,44.65 -35.54,44.72 -35.54,44.72 C-35.54,44.72 -35.54,44.6 -35.54,44.6 C-35.54,44.6 -35.48,44.46 -35.48,44.46 C-35.48,44.46 -35.33,44.14 -35.33,44.14 C-35.26,43.98 -35.05,43.53 -35.22,43.9 C-35.22,43.9 -35.49,44.48 -35.49,44.48 C-35.49,44.48 -35.52,44.55 -35.52,44.55 C-35.52,44.55 -35.54,44.59 -35.54,44.59 C-35.54,44.59 -35.69,44.36 -35.75,44.26 C-35.75,44.26 -36.71,42.74 -36.71,42.74 C-36.71,42.74 -38.64,39.71 -38.64,39.71 C-38.64,39.71 -54.04,15.45 -54.04,15.45 C-54.04,15.45 -69.76,-9.31 -69.76,-9.31 C-69.76,-9.31 -73.91,-15.85 -73.91,-15.85 C-73.91,-15.85 -87.55,-37.33 -87.55,-37.33 C-87.55,-37.33 -103.61,-22.21 -103.61,-22.21 C-103.61,-22.21 -110.45,-29.15 -110.45,-29.15 C-117.83,-20.91 -125.19,-12.64 -132.51,-4.34 C-132.51,-4.34 -35.51,94.98 -35.51,94.98 C-35.51,94.98 93.63,-29.99 93.63,-29.99 C93.63,-29.99 93.62,-30 93.62,-30z '
            />
          </g>
        </g>
        <g id='_R_G_L_3_G_M'>
          <g id='_R_G_L_3_G' transform=' translate(54.753, 60.859) scale(0.09922, 0.09922) translate(100.196, 23.156)'>
            <path
              id='_R_G_L_3_G_D_0_P_0'
              fill='#00f4d7'
              fillOpacity='1'
              fillRule='nonzero'
              d=' M-139 -5 C-140.34,-6.42 -147.56,-1.37 -144.5,3 C-143.62,4.25 -136.87,-2.75 -139,-5z '
            />
          </g>
        </g>
        <g id='_R_G_L_2_G_M'>
          <g id='_R_G_L_2_G' transform=' translate(55.185, 57.753) scale(0.09922, 0.09922) translate(88.834, 62.961)'>
            <path
              id='_R_G_L_2_G_D_0_P_0'
              fill='#00f4d7'
              fillOpacity='1'
              fillRule='nonzero'
              d=' M-110.55 -33.78 C-113.33,-39.26 -127.11,-24.85 -125.25,-20.88 C-124.25,-18.75 -108,-28.75 -110.55,-33.78z '
            />
          </g>
        </g>
        <g id='_R_G_L_1_G_M'>
          <g id='_R_G_L_1_G' transform=' translate(56.176, 52.311) scale(0.09922, 0.09922) translate(78.848, 117.805)'>
            <path
              id='_R_G_L_1_G_D_0_P_0'
              fill='#00f4d7'
              fillOpacity='1'
              fillRule='nonzero'
              d=' M-133.79 -28.12 C-131.96,-24.68 -118.65,-40.81 -122.17,-43.9 C-126.05,-47.31 -136.23,-32.73 -133.79,-28.12z '
            />
          </g>
        </g>
        <g id='_R_G_L_0_G_M'>
          <g id='_R_G_L_0_G' transform=' translate(64, 64) scale(0.09922, 0.09922) translate(0, 0)'>
            <path
              id='_R_G_L_0_G_D_0_P_0'
              fill='#00f4d7'
              fillOpacity='1'
              fillRule='nonzero'
              d=' M-105.7 -17.96 C-108.13,-19.96 -118.91,-11.85 -118.2,-11.14 C-115.84,-8.78 -103.17,-15.86 -105.7,-17.96z '
            />
          </g>
        </g>
      </g>
      <g id='time_group' />
    </svg>
  );
};

export default SVGSuccessAnimation;
